import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';

import { errorNormalizer } from '../../../../shared/Helpers/functions';
import { CustomButton, CustomTable } from '../../../../shared/uiComponents';
import SearchBar from '../../../../components/SearchBar';
import { ReportFilters, downloadFile } from '../../../Reports/helpers';
import { SoapNoteFilters, sessionTypes, statusLabels } from '../../User/tableInfo';
import { Headers, TableBody } from './tableInfo';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { downloadSoapNotes, getSoapNotesAdmin } from '../../../../redux/State/clientSlice/soapNoteSlice';
import { GetSoapNotesProperties } from '../../../../redux/API/ClientAPIHelpers/soapNoteProperties';

const SOAPNotes = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params, setParams] = useSearchParams();

	const page = params.get('page') || '1';
	const pageSize = params.get('pageSize') || '8';
	const direction = params.get('direction') || '';
	const orderBy = params.get('orderBy') || '';
	const searchString = params.get('search') || '';
	const status = params.get('status') || '';
	const sessionType = params.get('sessionType') || '';

	const soapNotes = useSelector((state) => state.soapNote.soapNotes);
	const filterData = useSelector((state) => state.billing.billingFilters);
	const loading = useSelector((state) => state.soapNote.loading);

	useEffect(() => {
		const { clientId, endDate, startDate, userId } = filterData;

		if (!startDate || !endDate) return;
		dispatch(
			getSoapNotesAdmin({
				page,
				pageSize,
				direction,
				orderBy,
				searchString,
				status,
				startDate,
				endDate,
				clientId,
				userId,
				sessionType,
			}),
		)
			.then(unwrapResult)
			.catch(errorNormalizer);
	}, [page, pageSize, direction, orderBy, searchString, status, filterData, sessionType, dispatch]);

	const pageSizeTotal = soapNotes.totalNumberOfItems ? soapNotes.totalNumberOfItems.toString() : '8';

	const activeFilterCount = (sessionType ? 1 : 0) + (status ? 1 : 0);

	const downloadHandler = () => {
		const { clientId, endDate, startDate, userId } = filterData;
		if (!startDate || !endDate) return;
		const data: GetSoapNotesProperties = {
			page,
			pageSize: pageSizeTotal,
			direction,
			orderBy,
			searchString,
			status,
			startDate,
			endDate,
			clientId,
			userId,
			sessionType,
		};

		dispatch(downloadSoapNotes(data))
			.then(unwrapResult)
			.then((response) => downloadFile(response))
			.catch(errorNormalizer);
	};

	return (
		<>
			<ReportFilters showUsers showShorcuts={false} />
			<div
				style={{
					display: 'flex',
					gap: '16px',
					alignItems: 'center',
					marginBottom: '16px',
				}}
			>
				<CustomButton
					onClick={downloadHandler}
					title="Download"
					loading={loading}
					style={{ marginTop: '8px' }}
				/>
				<SearchBar hasFilter activeFilterCount={activeFilterCount} style={{ marginTop: '8px' }} />
				<SoapNoteFilters />
			</div>
			{activeFilterCount > 0 && (
				<div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
					{sessionType && (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '4px',
								background: '#e8f4f8',
								borderRadius: '16px',
								padding: '4px 12px',
								fontSize: '13px',
							}}
						>
							<span>Type: {sessionTypes.find((s) => s.id === sessionType)?.name}</span>
							<span
								style={{ cursor: 'pointer', marginLeft: '4px', fontWeight: 'bold' }}
								onClick={() => {
									params.delete('sessionType');
									setParams(params);
								}}
							>
								×
							</span>
						</div>
					)}
					{status && (
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '4px',
								background: '#e8f4f8',
								borderRadius: '16px',
								padding: '4px 12px',
								fontSize: '13px',
							}}
						>
							<span>Status: {statusLabels[parseInt(status)]}</span>
							<span
								style={{ cursor: 'pointer', marginLeft: '4px', fontWeight: 'bold' }}
								onClick={() => {
									params.delete('status');
									setParams(params);
								}}
							>
								×
							</span>
						</div>
					)}
				</div>
			)}
			<CustomTable headers={Headers} data={soapNotes} TableBody={TableBody} loading={loading} hasMobile={false} />
		</>
	);
};

export default SOAPNotes;
